import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { RxCross1 } from "react-icons/rx";
import { IoAddSharp } from "react-icons/io5";
import { useSelector, useDispatch } from 'react-redux';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import AsyncSelect from 'react-select/async';

const DirectPurchaseGrid = ({ onRequisitionData, itemtype, itemData, selectedCheck, currencyPrecision }) => {

    const rows = useSelector(state => state.rows.rows);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [vat, setvat] = useState([]);
    const [items, setItems] = useState([]);
    const apiService = new ApiService();
    const dispatch = useDispatch();
    const [itemRows, setItemRows] = useState([]);
    const totalAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0)
    const totalVat = rows.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    const netAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)

    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getVat()
    }, []);

    // useEffect(() => {
    //     if (rows[0]?.ItemNo) {
    //         updatevat();
    //     }
    // }, [selectedCheck]);


    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, [itemtype]);

    const getVat = async () => {
        let vatParam = `?toPurchase=true`
        const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
        setvat(vat.data.result)
    }
    const updatevat = async () => {
        try {
            const updatedRows = rows.map(row => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const selectedVat = vat?.find(tax => tax.description === row?.vatDes);
                let amount = row.qty * row.baseAmount
                const perAmount = (amount / 100) * (selectedVat?.rate || 0)
                let excludedAmount = amount + perAmount
                const calculatedAmount = selectedCheck === true ? excludedAmount : amount;
                updatedRows[index].calculatedAmount = calculatedAmount;
                updatedRows[index].amount = calculatedAmount;
                updatedRows[index].vatDes = selectedVat?.description;
                updatedRows[index].vat = selectedVat?.rate || 0;
                updatedRows[index].vatAmount = perAmount;
                updatedRows[index].calculatedAmount = calculatedAmount;
                updatedRows[index].discount = row.discount || 0;
            });
            await Promise.all(apiPromises);
            setRows(updatedRows);
            onRequisitionData(updatedRows);
            dispatch(setRows(updatedRows));
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoader(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', itemtype?.value || "");
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            if (itemtype?.value) {
                setItemOptions(fetchedItems);
            } else {
                setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            }
            setLoader(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoader(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoader(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            params.append('ItemNo', itemtype?.value || "");

            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);

            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            if (itemtype?.value) {
                setDescriptionOptions(fetchedItems);
            } else {
                setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            }
            setLoader(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoader(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async (inputValue = "") => {
        if (inputValue?.trim().length < 3 || !hasMore || loader) return;

        setPage(prevPage => prevPage + 1);
        await fetchItemNo(inputValue, page + 1);
    };
    const loadMoreDescOptions = async (inputValue = "") => {
        if (inputValue.length < 3 || !hasMore || loader) return;

        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc(inputValue, desPage + 1);
    };
    const handleInputChange = async (index, fieldName, value) => {
        if (fieldName === "specification") {
            const updatedRows = [...rows];
            updatedRows[index] = {
                ...updatedRows[index],
                specification: value,
            };

            setRows(updatedRows);
            dispatch(setRows(updatedRows));
            onRequisitionData(updatedRows);
            return;
        }
        const updatedRows = await Promise.all(
            rows.map(async (row, rowIndex) => {
                if (rowIndex !== index) return row;
                const updatedRow = { ...row, srno: ('0' + (index + 1)).slice(-2) };
                // validations
 
                if (fieldName === 'ItemNo') {
                    const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemNo=${value}`);
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${value}`);
                    let glAccount = getGLAccounts?.data?.result[0]
                    let selectedItem = getunit?.data?.result[0];
                    const selectedVat = resolveVatForItem(vat, selectedItem?.vat);
                    if (selectedItem) {
                        updatedRow.itemDescription = selectedItem?.itemDescription;
                        updatedRow.ItemNo = selectedItem?.itemNo;
                        updatedRow.requisitionNo = selectedItem?.itemDescription;
                        updatedRow.uom = selectedItem.baseUnit;
                        updatedRow.specification = selectedItem?.specification;
                        updatedRow.vatDes = selectedVat?.description ?? '';
                        updatedRow.vat = selectedVat?.rate ?? 0;
                        updatedRow.stock = 0;
                        updatedRow.discount = 0;
                        updatedRow.baseAmount = 0;
                        updatedRow.avgPrice = selectedItem?.avgPrice?.toFixed(currencyPrecision || 3) || 0;
                        updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
                        updatedRow.inventoryAccountCode = glAccount?.inventoryAccountCode;
                        updatedRow.inventoryAccountName = glAccount?.inventoryAccountName;
                        updatedRow.GRNAccountName = glAccount?.grnAccountName;
                        updatedRow.GRNAccountCode = glAccount?.grnAccountCode;
                    }
                } else if (fieldName === 'itemDescription') {
                    const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemDescription=${value}`);
                    let selectedItem = getunit?.data?.result[0];
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${selectedItem?.itemNo}`);
                    let glAccount = getGLAccounts?.data?.result[0];

                    const selectedVat = resolveVatForItem(vat, selectedItem?.vat);
                    if (selectedItem) {
                        updatedRow.specification = selectedItem?.specification;
                        updatedRow.recordId = selectedItem?.itemNo;
                        updatedRow.itemDescription = selectedItem?.itemDescription;
                        updatedRow.ItemNo = selectedItem?.itemNo;
                        updatedRow.discount = 0;
                        updatedRow.stock = 0;
                        updatedRow.uom = selectedItem.baseUnit;
                        updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
                        updatedRow.vatDes = selectedVat?.description ?? '';
                        updatedRow.vat = selectedVat?.rate ?? 0;
                        updatedRow.baseAmount = 0;
                        updatedRow.avgPrice = selectedItem?.avgPrice?.toFixed(currencyPrecision || 3) || 0;
                        updatedRow.inventoryAccountCode = glAccount?.inventoryAccountCode;
                        updatedRow.inventoryAccountName = glAccount?.inventoryAccountName;
                        updatedRow.GRNAccountName = glAccount?.grnAccountName;
                        updatedRow.GRNAccountCode = glAccount?.grnAccountCode;
                    }
                }
                if (fieldName === 'qty') {

                    const quantity = parseFloat(value);
                    const convrate = row?.baseQty;
                    const { rate: vatRate } = resolveRowVat(vat, row?.vatDes);
                    const unitPrice = parseFloat(row.baseAmount || value || 0);
                    let amount = quantity * unitPrice;
                    let discountA = parseFloat(amount - (row?.discount || 0))
                    let discountAmt = discountA?.toFixed(currencyPrecision || 3)
                    const perAmount = parseFloat((discountAmt / 100) * vatRate);
                    let vatAMount = perAmount?.toFixed(currencyPrecision || 3)
                    let excludedAmount = parseFloat(discountAmt) + parseFloat(vatAMount);
                    const calculatedAmount = excludedAmount?.toFixed(currencyPrecision || 3);
                    updatedRow.amount = calculatedAmount;
                    updatedRow.calculatedAmount = discountAmt;
                    updatedRow.stock = convrate * quantity || 0;
                    updatedRow.vatAmount = vatAMount;
                    updatedRow.baseQty = parseFloat(convrate);
                    updatedRow.qty = quantity;
                    updatedRow.baseAmount = unitPrice;

                }
                if (fieldName === 'discount') {
                    const discount = parseFloat(value);
                    const unitPrice = parseFloat(row.baseAmount);

                    const grossAmount = Number(row.qty || 0) * Number(row.baseAmount || 0);
                    let itemDiscount = Number(discount || 0);

                    const afterDiscount = grossAmount - itemDiscount;
                    const vatRate = Number(row.vat || 0);
                    const vatAmount = parseFloat(afterDiscount * vatRate / 100);
                    let vatAMount = vatAmount?.toFixed(currencyPrecision || 3)
                    const finalAmount = parseFloat(afterDiscount) + parseFloat(vatAMount);
                    updatedRow.calculatedAmount = afterDiscount;
                    updatedRow.discountAmount = afterDiscount;
                    updatedRow.vatAmount = vatAMount || 0;
                    updatedRow.amount = finalAmount;
                    updatedRow.discount = discount || 0

                }
                if (fieldName === 'baseAmount') {

                    const convrate = row?.baseQty;
                    const { rate: vatRate } = resolveRowVat(vat, row?.vatDes);
                    const quantity = parseFloat(row?.qty || value);
                    const discount = parseFloat(row?.discount) || 0;
                    const unitPrice = parseFloat(value || 0);
                    let amount = parseFloat(quantity) * parseFloat(unitPrice);
                    let discountA = parseFloat(amount - (discount || 0))

                    let discountAmt = discountA?.toFixed(currencyPrecision || 3)
                    const perAmount = parseFloat((discountAmt / 100) * vatRate);
                    let vatAMount = perAmount?.toFixed(currencyPrecision || 3)
                    let excludedAmount = parseFloat(discountAmt) + parseFloat(vatAMount);
                    const calculatedAmount = excludedAmount;
                    updatedRow.stock = convrate * quantity || 0;
                    updatedRow.qty = quantity;
                    updatedRow.baseAmount = unitPrice;
                    updatedRow.amount = calculatedAmount;
                    updatedRow.calculatedAmount = discountAmt;
                    updatedRow.vatAmount = vatAMount || 0;

                }
                if (fieldName === "vat") {
                    const calculatedAmount =
                        parseFloat(row?.calculatedAmount) || 0;

                    const vatRate =
                        parseFloat(value?.rate) || 0;

                    const vatAmount =
                        (calculatedAmount * vatRate) / 100;

                    const finalAmount =
                        calculatedAmount + vatAmount;

                    updatedRow.vatDes =
                        value?.description || "";

                    updatedRow.vat =
                        vatRate;

                    updatedRow.calculatedAmount =
                        calculatedAmount;

                    updatedRow.vatAmount =
                        vatAmount.toFixed(currencyPrecision || 3);

                    updatedRow.amount =
                        finalAmount.toFixed(currencyPrecision || 3);
                }
                if (fieldName === "calculatedAmount") {
                    const calculatedAmount = parseFloat(value) || 0;
                    const vatRate = Number(updatedRow?.vat || 0);

                    const vatAmount = truncateAmount(
                        (calculatedAmount * vatRate) / 100,
                        currencyPrecision || 3
                    );

                    const finalAmount = truncateAmount(
                        calculatedAmount + vatAmount,
                        currencyPrecision || 3
                    );

                    updatedRow.calculatedAmount = calculatedAmount;
                    updatedRow.vatAmount = vatAmount;
                    updatedRow.amount = finalAmount;

                    return updatedRow;
                }
                return updatedRow;
            })
        );

        setRows(updatedRows);
        dispatch(setRows(updatedRows));
        onRequisitionData(updatedRows);
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            ItemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: ''
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        setItemRows(updatedRows);
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        setItemRows(updatedRows)
        dispatch(setRows(updatedRows));
        setRows(updatedRows);
    };
    const handleDateChange = (index, expDate) => {
        const updatedRows = [...rows];
        updatedRows[index].expDate = expDate;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, expDate: expDate } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const handleBatchNo = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].batchNo = value;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, batchNo: value } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const truncateAmount = (value, decimals = 3) => {
        const num = Number(value) || 0;
        const factor = Math.pow(10, decimals);

        return Math.trunc(num * factor) / factor;
    };
    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className='dynoTable' >
                        <tr>
                            <th></th>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Unit Price</th>
                            <th>Discount</th>
                            <th>Calculated Amount</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Batch No</th>
                            <th>expDate</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Array.isArray(rows) && rows.map((row, index) => (
                            <tr key={index}>
                                {itemData?.requisitionNo ?
                                    <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                        <div className='center'> <RxCross1 size={15} /></div></td> :
                                    <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                        {itemData?.eye === true ?
                                            <div className='center'><RxCross1 size={15} /></div> :
                                            <div onClick={() => handleRemoveRow(index)} className='center'><RxCross1 size={15} /></div>
                                        }
                                    </td>
                                }
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.srno} disabled style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'>
                                    {itemData?.eye === true ?
                                        <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.ItemNo} style={{ width: "100px" }} /></td>
                                        :
                                        <AsyncSelect
                                            cacheOptions
                                            value={{ value: row.ItemNo, label: row.ItemNo }}
                                            options={itemOptions}
                                            isDisabled={itemData?.eye === true ? true : false}
                                            loadOptions={loadOptions}
                                            onChange={selectedOption => handleInputChange(index, 'ItemNo', selectedOption.label)}
                                            defaultOptions={itemOptions}
                                            onMenuScrollToBottom={loadMoreOptions}
                                            noOptionsMessage={({ inputValue }) =>
                                                inputValue.length < 3
                                                    ? "Type at least 3 characters..."
                                                    : "No records found"
                                            }
                                        />
                                    }
                                </td>
                                <td className='m-0 p-0'>
                                    {itemData?.eye === true ?
                                        <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.itemDescription} style={{ width: "120px" }} /></td>
                                        : <AsyncSelect
                                            cacheOptions
                                            value={{ value: row.itemDescription, label: row.itemDescription }}
                                            isDisabled={itemData?.eye === true ? true : false}
                                            options={descriptionOptions}
                                            loadOptions={loadDescOptions}
                                            onChange={selectedOption => handleInputChange(index, 'itemDescription', selectedOption.label)}
                                            className="w-100 p-0"
                                            defaultOptions={descriptionOptions}
                                            onMenuScrollToBottom={loadMoreDescOptions}
                                            noOptionsMessage={({ inputValue }) =>
                                                inputValue.length < 3
                                                    ? "Type at least 3 characters..."
                                                    : "No records found"
                                            }
                                        />}
                                </td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.specification} style={{ width: "120px" }}
                                    onChange={e => handleInputChange(index, 'specification', e.target.value)} disabled={itemData?.eye === true ? true : false} /></td>
                                <td className='m-0 p-0'><input className='p-2' onWheel={(e) => e.target.blur()} disabled={itemData?.eye === true ? true : false}
                                    type="number" value={row.qty} onKeyDown={preventNegativeSign}
                                    style={{ width: "90px" }} onChange={e => handleInputChange(index, 'qty', e.target.value)} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" style={{ width: "140px" }} value={row.uom} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.stock || 0} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="number" onWheel={(e) => e.target.blur()} disabled={itemData?.eye === true ? true : false}
                                    value={row?.baseAmount} onKeyDown={preventNegativeSign}
                                    style={{ width: "120px" }} onChange={e => handleInputChange(index, 'baseAmount', e.target.value)} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.discount} style={{ width: "100px" }} /></td>
                                {/* Calculated Amount */}
                                <td
                                    className="m-0 p-0"
                                >
                                    <input
                                        className="p-2"
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        onKeyDown={preventNegativeSign}
                                        value={row?.calculatedAmount ?? ""}
                                        onChange={(e) =>
                                            handleInputChange(
                                                index,
                                                "calculatedAmount",
                                                e.target.value
                                            )
                                        }
                                    />
                                </td>
                                <td className='m-0 p-0'>
                                    <Select className="flex-grow-1"
                                        theme={(theme) => ({
                                            ...theme,
                                            padding: 10
                                        })}
                                        value={{ value: row.vatDes, label: row.vatDes }}
                                        options={vat?.map((vat) => ({ value: vat, label: vat?.description }))}
                                        onChange={selectedOption => handleInputChange(index, 'vat', selectedOption.value)} />
                                </td>
                                <td className='m-0 p-0'><input className='p-2' type="text"
                                    value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' style={{ width: "120px" }} disabled type="text"
                                    value={(row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0)} /></td>
                                <input
                                    className='p-2' onWheel={(e) => e.target.blur()}
                                    type="number" style={{ width: "120px" }}
                                    value={row.batchNo}
                                    onKeyDown={preventNegativeSign}
                                    onChange={(e) => handleBatchNo(index, e.target.value)}
                                />
                                <td className='m-0 p-0'><input className='p-2' type='date' value={row?.expDate ? row.expDate.split('T')[0] : ''} disabled={itemData?.eye === true ? true : false}
                                    onChange={(e) => handleDateChange(index, e.target.value)} style={{ width: "130px" }} /></td>
                            </tr>
                        ))}
                    </tbody>

                </table>
                <div className='d-flex gap-5'>
                    {itemData?.eye === true ? "" :
                        <button className='mainbtn  mt-4 gap-3' onClick={addNewRow}><IoAddSharp color='#fff' className='center mt-1 mx-2' /><div>Add</div>  </button>
                    }
                </div>
            </div>
            <div className='d-flex justify-content-between boxs'>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Discount</div>
                    <div className='field'>---</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Amount</div>
                    <div className='field'>{totalAmount?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Discount</div>
                    <div className='field'>---</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Vat</div>
                    <div className='field'>{totalVat?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Net Amount</div>
                    <div className='field'>{netAmount?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
            </div>
        </div>
    );
};

export default DirectPurchaseGrid;
export const resolveRowVat = (vatList, vatDes) => {
    const list = Array.isArray(vatList) ? vatList : [];
    const fallback = getDefaultVatOption(list);
    if (!fallback) {
        return { tax: null, rate: 0, description: '' };
    }
    const hasValidDec = vatDes !== undefined && vatDes !== null && vatDes !== '' && vatDes !== 0;
    const matched = hasValidDec ? list.find((tax) => tax.description === vatDes) : null;
    const tax = matched || fallback;
    return {
        tax,
        rate: tax.rate ?? 0,
        description: tax.description ?? '',
    };
};

export const resolveVatForItem = (vatList, itemVatDescription) => {
    const list = Array.isArray(vatList) ? vatList : [];
    if (itemVatDescription) {
        const fromItem = list.find((tax) => tax.description === itemVatDescription);

        if (fromItem) return fromItem;
    }
    return getDefaultVatOption(list);
};
export const getDefaultVatOption = (vatList) => (Array.isArray(vatList) && vatList.length > 0 ? vatList[0] : null);
